import styled, { createGlobalStyle } from "styled-components";

export const PrimaryColor = "#00239E";
export const MaterialCubicBezier = "cubic-bezier(0.4, 0.0, 0.2, 1)";
export const MobileWidth = "767px";
export const SectionPadding = "80px 0";
export const SectionPaddingMobile = "50px 0";

export const Wrapper = styled.div`
  margin: 0 auto;
  max-width: 1100px;
  width: 100%;

  @media screen and (max-width: ${MobileWidth}) {
    padding: 0 20px;
  }
`;

export const Title = styled.div`
  font-family: "Fjalla One", "Open Sans", sans-serif;
  font-size: 3rem;
  text-align: center;
  text-transform: uppercase;
  @media screen and (max-width: ${MobileWidth}) {
    font-size: 2.2rem;
  }
`;

const GlobalStyle = createGlobalStyle`
  * {
    box-sizing: border-box;
  }
  
  :root {
    font-size: 14px;
  }
  
  html {
    scroll-behavior: smooth;
  }
  
  body {
    margin: 0;
    background-color: #fff;
    font-family: 'Open Sans', sans-serif;
  }
  
  a {
    text-decoration: none;
    transition: all 200ms ${MaterialCubicBezier};
  }
  
  button {
    cursor: pointer;
    outline: 0;
    transition: all 400ms ${MaterialCubicBezier};
  }
  
  .btn {
    background-color: ${PrimaryColor};
    border: 0;
    border-radius: 6px;
    color: #fff;
    font-weight: bold;
    padding: 15px 25px;
    text-transform: uppercase;
    &:hover {
      background-color: #001c7b;
    }
  }
`;

export default GlobalStyle;
